module.exports = __webpack_public_path__ + "static/media/ty-icon.31347984.svg";